import { render, staticRenderFns } from "./FinalList.vue?vue&type=template&id=6da2ec8c&scoped=true"
import script from "./FinalList.vue?vue&type=script&lang=js"
export * from "./FinalList.vue?vue&type=script&lang=js"
import style0 from "./FinalList.vue?vue&type=style&index=0&id=6da2ec8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2ec8c",
  null
  
)

export default component.exports